import httpClient, { ApiResponseType } from 'packages/http_client';
import { FORM_DATA_CONFIG } from 'packages/http_client/utils';
import {
  CreateInvoiceType,
  CreateInvoicePayload,
  CreateInvoiceApiResponseType,
  CreateInvoiceResponse,
  InvoiceType,
} from '../types';
import {
  INVOICE_API,
  convertCreateInvoiceRequestPayload,
} from '../utils';

export type GetInvoicesResponse = {
  result: InvoiceType[];
  status: string;
};

const createInvoiceApi = (payload: CreateInvoicePayload) => {
  const url = INVOICE_API;
  return httpClient.post<ApiResponseType<CreateInvoiceApiResponseType>>(url, payload, FORM_DATA_CONFIG);
};

export const createInvoice = async (data: CreateInvoiceType): Promise<CreateInvoiceResponse> => {
  const requestPayload = convertCreateInvoiceRequestPayload(data);
  const response = await createInvoiceApi(requestPayload);
  const { error, httpStatus, data: responseData } = response;
  return { error, httpStatus, data: responseData?.id[0] };
};

// Legacy function for backward compatibility
export const getInvoicesByServiceRequestId = async (serviceRequestId: number): Promise<GetInvoicesResponse> => {
  const url = INVOICE_API;
  const { data } = await httpClient.get<ApiResponseType<GetInvoicesResponse>>(url, {
    params: { service_request_id: serviceRequestId },
  });
  if (!data) return { result: [], status: 'error' };
  return data;
};
